import { accountActions } from 'store/actions/account';
import moment from 'moment';
import config from 'Config';

const mapAccount = (account) => (
  account && {
    ...account,
    isMinor: moment(account.date_of_birth).add(config.adultYears, 'years').isAfter(),
  }
);

export default {
  account: (state = null, action) => (
    action.type === accountActions.SET_ACCOUNT ? mapAccount(action.payload) : state
  ),
  dob: (state = null, action) => (
    action.type === accountActions.SET_DOB ? action.payload : state
  ),
};
